/**
 * Category Helper Functions
 * Extracted from ResultAndRevision.js for better organization
 * 
 * IMPORTANT: These functions should use the centralized validation from validCategories.js
 */

import { 
  VALID_CATEGORIES, 
  ENGLISH_CATEGORIES, 
  IRISH_CATEGORIES, 
  FILIOCHT_CATEGORIES,
  validateCategory 
} from './validCategories';

/**
 * Check if the category is a GCSE English category
 */
export function isGCSECategory(category) {
  return category === 'GCSE_Shakespeare' || 
         category === 'GCSE_19th' || 
         category === 'GCSE_Poetry' || 
         category === 'GCSE_Inspector';
}

/**
 * Check if the category is an Oral category
 */
export function isOralCategory(category) {
  return category === 'IE_Oral' || 
         category === 'FR_Oral' || 
         category === 'ES_Oral' || 
         category === 'DE_Oral';
}

/**
 * Check if the category is an English category
 */
export function isEnglishCategory(category) {
  return ENGLISH_CATEGORIES.has(category);
}

/**
 * Check if the category is a GCSE Language category
 */
export function isGCSELanguageCategory(category) {
  return category === 'GCSE_French_Q1' || 
         category === 'GCSE_French_Q2' || 
         category === 'GCSE_Spanish_Q1' || 
         category === 'GCSE_Spanish_Q2' || 
         category === 'GCSE_German_Q1' || 
         category === 'GCSE_German_Q2' ||
         category === 'GCSE_FR_Grammar' || 
         category === 'GCSE_ES_Grammar' || 
         category === 'GCSE_DE_Grammar';
}

/**
 * Determine subject from category
 */
export const getCategorySubject = (category) => {
  // Use centralized category validation
  if (ENGLISH_CATEGORIES.has(category) || (category && category.startsWith('GCSE_'))) {
    return 'English';
  } else if (IRISH_CATEGORIES.has(category)) {
    return 'Irish';
  } else if (category && category.startsWith('FR_')) {
    return 'French';
  } else if (category && category.startsWith('ES_')) {
    return 'Spanish';
  } else if (category && category.startsWith('DE_')) {
    return 'German';
  } else if (category && category.startsWith('MATH_')) {
    return 'Maths';
  } else {
    return 'English'; // Default to English
  }
}; 